"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _saraivaUi = require("@minha-biblioteca/saraiva-ui");
var _contexts = require("../../contexts");
var _services = require("../../services");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable react/jsx-no-bind */

var CopyrightDialog = () => {
  var HASH = 'copyright';
  var [hash, setHash] = (0, _react.useState)(global.location.hash);
  var [onHashChangeCallback, setOnHashChangeCallback] = (0, _react.useState)();
  var {
    openCopyrightDialog,
    setOpenCopyrightDialog,
    setOpenCopyTextDialog
  } = (0, _react.useContext)(_contexts.CopyrightContext);
  var {
    applicationToken,
    sessionToken,
    userId,
    uuid
  } = (0, _react.useContext)(_contexts.EpubReaderContext);
  var service = (0, _services.CopyrightService)(applicationToken, sessionToken);
  var handleConfirm = () => {
    service.setCopyright(userId, uuid, true);
    setOpenCopyrightDialog(false);
    setOnHashChangeCallback(() => () => setOpenCopyTextDialog(true));
  };
  var handleConfirmWithoutCheck = () => {
    setOpenCopyrightDialog(false);
    setOnHashChangeCallback(() => () => setOpenCopyTextDialog(true));
  };
  (0, _react.useEffect)(() => {
    function onHashChange() {
      if (onHashChangeCallback) {
        onHashChangeCallback();
        setOnHashChangeCallback();
      }
    }
    window.addEventListener('hashchange', onHashChange);
    return () => window.removeEventListener('hashchange', onHashChange);
  }, [onHashChangeCallback]);
  (0, _react.useEffect)(() => {
    function onBackNavigation() {
      if (hash.includes(HASH)) {
        setOpenCopyrightDialog(false);
      }
      setHash(global.location.hash);
    }
    window.addEventListener('hashchange', onBackNavigation);
    return () => window.removeEventListener('hashchange', onBackNavigation);
  }, [hash, setOpenCopyrightDialog]);
  (0, _react.useEffect)(() => {
    if (openCopyrightDialog) {
      global.location.hash = HASH;
    } else if (global.location.hash.includes(HASH)) {
      window.history.back();
    }
  }, [openCopyrightDialog]);
  return /*#__PURE__*/_react.default.createElement(_saraivaUi.Dialog, {
    open: openCopyrightDialog,
    size: "md",
    title: "Alerta sobre direitos autorais",
    secondaryButton: "cancelar",
    primaryButton: "aceitar",
    label: "N\xE3o desejo mais ver esse alerta!",
    alert: true,
    handleClose: () => setOpenCopyrightDialog(false),
    handleConfirm: handleConfirm,
    confirmWithoutCheck: handleConfirmWithoutCheck,
    alertMessage: true
  }, "A c\xF3pia de conte\xFAdo deste livro \xE9 limitada e n\xE3o deve ser utilizada para fins comerciais.");
};
var _default = exports.default = CopyrightDialog;